module.exports = __webpack_public_path__ + "img/germany.9a4e98b9.svg";